// Static site data for Beautify - Deborah Louise Beauty, Cornwall

export const BRAND = {
  name: "Beautify",
  tagline: "Beauty & Massage",
  therapist: "Deborah Louise",
  phone: "07572 905 098",
  phoneTel: "+447572905098",
  email: "beautifycornwalluk@gmail.com",
  facebook: "https://www.facebook.com/p/Deborah-Louise-Beauty-Cornwall-100066713829864/?locale=en_GB",
  review_google_url: "",
  review_facebook_url: "https://www.facebook.com/p/Deborah-Louise-Beauty-Cornwall-100066713829864/?locale=en_GB",
  area: "Wadebridge, Cornwall",
  reviewsSummary: { rating: "100%", count: 65 },
};

export const IMAGES = {
  logo: "/api/uploads/logo.png",
  workspace:
    "/images/workspace.jpg",
  deborah:
    "/images/deborah.jpg",
  hotStones:
    "https://images.unsplash.com/photo-1610402601271-5b4bd5b3eba4?crop=entropy&cs=srgb&fm=jpg&q=70&w=900",
  facial:
    "/images/facial.jpg",
  manicure:
    "https://images.unsplash.com/photo-1659391542239-9648f307c0b1?crop=entropy&cs=srgb&fm=jpg&q=70&w=900",
  lash1:
    "/images/lash1.jpg",
  lash2:
    "/images/lash2.jpg",
  spa:
    "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&q=70&w=900",
  storefront:
    "/images/storefront.jpg",
};

export const FAQS = [
  {
    q: "Do I need to pay a deposit when I book?",
    a: "Yes — a 50% deposit is taken to secure your appointment. Please give at least 24 hours' notice if you need to amend or cancel; late cancellations and no-shows are charged the full treatment price and the deposit is lost.",
  },
  {
    q: "Where are the studios, and is there parking?",
    a: "Beautify runs from two Wadebridge studios: Unit 20, Dunveth Business Park (Thursdays), which has free parking right outside, and Elixir Health at 47 Molesworth Street (Fridays & Saturdays), in the town centre just a short walk from Wadebridge's public car parks.",
  },
  {
    q: "What should I expect on my first visit?",
    a: "Arrive a few minutes early so we can have a quick chat about what you'd like and anything I should know (allergies, pregnancy, areas to focus on). Every treatment is then tailored to you — using organic Dr. Hauschka skincare and carefully chosen aromatherapy-based products — so you can simply switch off and relax.",
  },
  {
    q: "Do you take walk-in appointments?",
    a: "Yes — walk-in appointments are available at Elixir Health on Molesworth Street on Fridays and Saturdays, subject to availability. Booking ahead is always recommended so you get the time that suits you best.",
  },
  {
    q: "Can I book more than one treatment in a visit?",
    a: "Absolutely. You can add as many treatments as you like to one enquiry using the form above, and Deborah will plan the timings for you. Keep an eye on the monthly specials for combination treatments too.",
  },
  {
    q: "Do you offer gift vouchers, pamper parties or mobile treatments?",
    a: "Yes to all three! Gift vouchers make a lovely treat, and pamper parties or mobile treatments bring the full treatment list to your own home — perfect for birthdays, hen parties and baby showers. Just choose the matching option in the enquiry form.",
  },
  {
    q: "How does booking work?",
    a: "Send an enquiry through the website (or call 07572 905 098) with your preferred day and time. Deborah replies personally to confirm your appointment and arrange the deposit — you'll also receive an email confirmation with a calendar invite.",
  },
];

export const CONTENT = {
  home: {
    heading_line1: "Welcome",
    heading_line2: "to Beautify.",
    lead: "Hi, I'm Deborah, owner of Beautify.",
    paragraphs: [
      "With over fifteen years' experience in the beauty and wellbeing industry, I am passionate about creating treatments that not only make you feel and look your best, but give you the chance to completely relax, unwind and enjoy some well-deserved time for yourself.",
      "From beauty treatments and facials to specialised massages, every treatment is tailored to you and your individual needs. My aim is for you to leave feeling brighter, lighter and completely relaxed — or, as many of my clients say, *“floating out the door.”*",
      "I use beautiful **Dr. Hauschka** skincare within my facials, alongside carefully chosen aromatherapy-based massage products, to make your treatment feel that little bit more special.",
      "Beautify is based in Wadebridge, Cornwall, where I offer a warm, friendly and tranquil space for you to switch off from everyday life and simply enjoy being looked after.",
    ],
    signoff: "I look forward to welcoming you to Beautify.",
    signature: "— Deborah Louise",
  },
  about: {
    lead: "Hi, I'm Deborah.",
    paragraphs: [
      "I'm passionate about promoting natural beauty and pride myself on using high-quality, carefully chosen products within my treatments. This includes the organic **Dr. Hauschka** skincare range for my facials and **Spa Ritual** nail polishes for my traditional manicures — beautiful plant-based formulas and colours inspired by nature.",
      "My aim is to always deliver the highest quality treatments, tailored to each individual client, so you're sure to leave feeling *relaxed, rejuvenated and pampered*.",
      "I work from two beautiful locations in Wadebridge, offering a range of appointment times to fit around everyday life — including early mornings, lunchtimes and Friday evening appointments.",
    ],
    signoff: "I look forward to welcoming you through the beautiful doors.",
  },
};

export const TREATMENTS = {
  massage: [
    { name: "Swedish back massage", duration: "30 mins", price: "£35" },
    { name: "Swedish full body massage", duration: "60 mins", price: "£60" },
    { name: "Hot Stones back massage", duration: "30 mins", price: "£45" },
    { name: "Hot Stones full body massage", duration: "60 mins", price: "£70" },
    { name: "Indian head massage", duration: "30 mins", price: "£35" },
    { name: "Warm bamboo full body massage", duration: "60 mins", price: "£65" },
    { name: "Thai compress back massage", duration: "30 mins", price: "£45" },
    { name: "Pregnancy massage", duration: "50 mins", price: "£60" },
    { name: "Lomi Lomi back massage", duration: "30 mins", price: "£45" },
    { name: "Lomi Lomi full body massage", duration: "60 mins", price: "£70" },
  ],
  beauty: [
    { name: "Luxury facial", duration: "60 mins", price: "£65" },
    { name: "Express facial", duration: "30 mins", price: "£40" },
    { name: "Luxury manicure", duration: "60 mins", price: "£40" },
    { name: "Express manicure", duration: "30 mins", price: "£30" },
    { name: "Express pedicure", duration: "30 mins", price: "£35" },
    { name: "Shellac gel polish", duration: "30 mins", price: "£30" },
    { name: "Biab overlays", duration: "45 mins", price: "£35" },
    { name: "Lash lift", duration: "45 mins", price: "£40" },
    { name: "Lash tint", duration: "20 mins", price: "£15" },
    { name: "Eyebrow tint", duration: "15 mins", price: "£7" },
    { name: "Eyebrow wax/shape", duration: "20 mins", price: "£10" },
    { name: "Waxing", duration: "varies", price: "from £7" },
    { name: "Lash extensions", duration: "90 mins", price: "from £45" },
    { name: "Lash infills", duration: "60 mins", price: "from £30" },
  ],
};

export const OFFERS = {
  active: true,
  month: "2026-08",
  title: "August special offers",
  subtitle: "Treat yourself this month",
  items: [
    { name: "Eyebrow wax/shape", price: "£8" },
    { name: "Lash lift and tint", price: "£35" },
    { name: "Swedish Himalayan salt stone back massage (30 mins)", price: "£40" },
    { name: "Combination treatment · Luxury Dr Hauschka facial + Swedish back massage", price: "£80" },
  ],
  footer_note: "Beautiful results you'll love — book your appointment today",
};


export const LOCATIONS = [
  {
    id: "dunveth",
    name: "Unit 20, Dunveth Business Park",
    fullName: "Unit 20, Dunveth Business Park",
    address: "Unit 20, Dunveth Business Park, Wadebridge, Cornwall",
    hours: "Thursdays · 9:00am – 4:30pm",
    day: "Thursday",
  },
  {
    id: "elixir-fri",
    name: "Elixir Health · Friday",
    fullName: "Elixir Health (Friday)",
    address: "47 Molesworth Street, Wadebridge, Cornwall",
    hours: "Fridays · 9:30am – 8:00pm",
    day: "Friday",
  },
  {
    id: "elixir-sat",
    name: "Elixir Health · Saturday",
    fullName: "Elixir Health (Saturday)",
    address: "47 Molesworth Street, Wadebridge, Cornwall",
    hours: "Saturdays · 9:30am – 4:30pm",
    day: "Saturday",
  },
];

export const REVIEWS = [
  {
    name: "Becky Johnson",
    date: "August 2026",
    text: "Every massage is completely tailored to exactly what I need, and somehow she always knows where I'm holding tension without me even having to explain. I've had massages from several therapists over the years, and Debs is, without question, the best I've ever been to.",
    treatment: "Massage",
  },
  {
    name: "Debbie Gregory",
    date: "June 2026",
    text: "I can't recommend Deborah Louise at Beautify highly enough. She has given me some truly wonderful massages that always leave me feeling relaxed, refreshed and well cared for — and her manicures are always beautifully done with great attention to detail. Every appointment feels like a treat.",
    treatment: "Massage · Lashes · Manicure",
  },
  {
    name: "Alexia Dranidis",
    date: "June 2026",
    text: "Her massages are so relaxing and just the right pressure for me. The small touches like the sound healing at the end or the beautiful playlists — everything is curated in a way which is individually tailored. She is skilled, intuitive and just the loveliest person!",
    treatment: "Massage · Lash lift & tint",
  },
  {
    name: "Amanda Taylor",
    date: "August 2026",
    text: "Deborah is amazing — she is my go-to for a massage or facial. My absolute favourite is her Crystal Massage: it boosts my energy as well as relaxing my muscles. It's not a luxury but a necessity.",
    treatment: "Crystal massage · Facials",
  },
  {
    name: "Katy Falconer",
    date: "August 2026",
    text: "I've been going to Deborah at Beautify for years and honestly wouldn't go anywhere else. She puts so much care into everything she does and always makes you feel completely relaxed and looked after.",
    treatment: "Massage · Pedicure",
  },
  {
    name: "Sarah Davies",
    date: "August 2026",
    text: "The treatments offered are wonderfully relaxing and healing. Deborah is warm and kind, intuitive and always knows what would serve me best on the day. I always come away lighter and more positive. A definite 5 stars.",
    treatment: "Holistic treatments",
  },
  {
    name: "Julia Dingle",
    date: "August 2026",
    text: "I love going to Deborah for my lash lift and tint. As well as the beauty treatment, she also includes a lovely, relaxing massage which is such a treat!",
    treatment: "Lash lift & tint",
  },
  {
    name: "Amy Spark",
    date: "August 2026",
    text: "Great service! So relaxing and I was over the moon with my lash lift. Highly recommend.",
    treatment: "Lash lift",
  },
  {
    name: "Mary Thomas",
    date: "June 2026",
    text: "I always feel very comfortable having any treatments with Deb — she is very thorough, hygiene levels are very high and the end results are five star.",
    treatment: "Beauty treatments",
  },
  {
    name: "Laura May",
    date: "23 April 2025",
    text: "Deborah is a fantastic massage therapist. I highly recommend her treatments. She is very friendly, professional and always ensures you feel amazing after her treatments. The Dr Hauschka products she uses are divine too!",
    treatment: "Massage",
  },
  {
    name: "Beth Morgan",
    date: "17 March 2025",
    text: "Had some wonderful treatments with Deborah, she is professional and caring with her treatments. 100% recommend.",
    treatment: "Multiple treatments",
  },
  {
    name: "Toni Louise Brewer",
    date: "4 October 2025",
    text: "I had a lovely hot stone massage with Deborah, very welcoming, informative and so relaxing, felt lovely afterwards. Would very much recommend this treatment.",
    treatment: "Hot Stone Massage",
  },
  {
    name: "Sarah Jane Thompson",
    date: "7 September 2024",
    text: "Highly recommend Deborah. Had my first ever Crystal Massage. The treatment was amazing, feel so relaxed. I've even booked another treatment. Thank you so much xx",
    treatment: "Crystal Massage",
  },
];
